module.exports = __webpack_public_path__ + "img/mazurian-white-free.47e9c35.svg";